<script lang="ts">
    import {
        KEY_ARROW_DOWN,
        KEY_ARROW_UP,
        KEY_ENTER,
        KEY_TAB,
    } from "@/constants";
    import { createEventDispatcher, tick } from "svelte";

    import SelectItem from "./SelectItem.svelte";
    import type { ItemType } from "./types";

    export let items: ItemType[];
    export let searchValue = "";
    export let selectedOption: string | number;
    export let listOpen: boolean;
    export let searchable = false;

    let listElement: null | HTMLDivElement;
    let hoveredItemIndex = 0;
    const dispatch = createEventDispatcher();

    const handleSelect = (item: ItemType) => {
        dispatch("select", item);
    };

    const handleKeydown = (e: KeyboardEvent) => {
        switch (e.key) {
            case KEY_ARROW_UP:
                hoveredItemIndex = Math.max(0, hoveredItemIndex - 1);
                break;
            case KEY_ARROW_DOWN:
                hoveredItemIndex = Math.min(
                    filteredItems.length - 1,
                    hoveredItemIndex + 1
                );
                break;
            case KEY_ENTER:
                handleSelect(filteredItems[hoveredItemIndex]);
                break;
            case KEY_TAB:
                hoveredItemIndex =
                    (hoveredItemIndex + 1) % filteredItems.length;
                break;
        }
    };

    const setFocus = async () => {
        await tick();
        listElement?.focus();
    };

    $: filteredItems = !searchable
        ? items
        : items.filter((item) =>
              item.label.toLowerCase().includes(searchValue.toLowerCase())
          );

    $: if (listOpen && searchValue) {
        hoveredItemIndex = filteredItems.findIndex((item) =>
            item.label.toLowerCase().includes(searchValue.toLowerCase())
        );
    }

    $: if (listOpen && !searchable) {
        setFocus();
    }
</script>

{#if listOpen}
    <div
        class="gw-select-list"
        bind:this={listElement}
        on:keydown={handleKeydown}
    >
        <ul
            class="gw-select-list__actions"
            role="listbox"
            aria-labelledby="selected-option-label"
        >
            {#each filteredItems as item (item.value)}
                <SelectItem
                    on:click={() => handleSelect(item)}
                    ariaSelected={selectedOption === item.value}
                >
                    {item.label}
                </SelectItem>
            {/each}
        </ul>
    </div>
{/if}

<style>
    .gw-select-list {
        position: var(--listPosition, absolute);
        z-index: var(--listZIndex, var(--gw-z-index-select));
        right: var(--listRight, 0);
        left: var(--listLeft, 0);
        top: var(--listTop, 40px);
        width: 100%;
        max-height: var(--listMaxHeight, 250px);
        overflow-y: auto;
        border: var(--listBorder, none);
        border-radius: var(--listBorderRadius, 4px);
        background: var(--listBackground, #fff);
        box-shadow: var(--listShadow, 0 2px 3px 0 rgba(44, 62, 80, 0.24));
    }
    .gw-select-list__actions {
        margin: 0;
        padding: 0 0.2rem;
        list-style: none;
    }
</style>
